<template>
  <div class="selfPanel">
    <div class="selfPanelContent">
      <Divider orientation="left">台账详情</Divider>
      <template v-if="ledgerForm.appId !='emergency' && ledgerForm.icSubType == 'HL_MS'">
        <table class="callRecordTable">
          <tr>
            <td>数据来源</td>
            <td>{{getDataSourceName(currentCallRecord?.dataSource)}}</td>
            <td>状态</td>
            <td>{{currentCallRecord?.statusLabel}}</td>
          </tr>
          <tr>
            <td>咨询时间</td>
            <td>{{currentCallRecord?.callTime}}</td>
            <td>呼入号码</td>
            <td>{{currentCallRecord?.callPhone | desensitizedPhone}}</td>
          </tr>
          <tr>
            <td>接通时间</td>
            <td>{{currentCallRecord?.putThroughTime}}</td>
            <td>挂断时间</td>
            <td>{{currentCallRecord?.hangUpTime}}</td>
          </tr>
          <tr>
            <td>服务律师</td>
            <td>{{currentCallRecord?.lawyerName}}</td>
            <td>律师号码</td>
            <td>{{currentCallRecord?.lawyerPhone}}</td>
          </tr>
          <tr>
            <td>等待时长（秒）</td>
            <td>{{currentCallRecord?.waitTime}}</td>
            <td>通话时长（秒）</td>
            <td>{{currentCallRecord?.callDuration}}</td>
          </tr>
          <tr>
            <td>是否已评价</td>
            <td>{{currentCallRecord?.satisfactionEvaluated?'是':'否'}}</td>
            <td>满意度结果</td>
            <td>{{currentCallRecord?.satisfactionResultLabel}}</td>
          </tr>
          <tr v-if="fileUrl">
            <td>录音文件</td>
            <td colspan="3">
              <audio
                :controlslist="showControlslist"
                controls
                ref="audio"
                style="padding: 8px; min-width: 100%;"
                width="100%"
              >
                <source :src="fileUrl" />
              </audio>
            </td>
          </tr>
        </table>
      </template>
      <template v-else-if="ledgerForm.appId !='emergency' && ledgerForm.icSubType == 'HL_FP'">
        <table
          class="callRecordTable"
          v-if="['INBOUND', 'OUTBOUND'].indexOf(currentCallRecord?.callType )>= 0"
        >
          <tr>
            <td>呼叫类型</td>
            <td>{{callTypes[currentCallRecord?.callType] || '--'}}</td>
            <td>{{callTypes[currentCallRecord?.callType] || '开始'}}时间</td>
            <td>{{currentCallRecord?.startTime}}</td>
          </tr>
          <tr>
            <td>接听时间</td>
            <td>{{currentCallRecord?.establishedTime || '--'}}</td>
            <td>结束时间</td>
            <td>{{currentCallRecord?.releaseTime || '--'}}</td>
          </tr>
          <tr>
            <td>通话时长</td>
            <td>{{currentCallRecord?.callDuration || '--'}}</td>
            <td>挂断方</td>
            <td>{{currentCallRecord?.releaseInitiator || '--'}}</td>
          </tr>
          <tr>
            <td>主叫号码</td>
            <td>{{currentCallRecord?.caller}}</td>
            <td>主叫归属地</td>
            <td>{{currentCallRecord?.callerLocation}}</td>
          </tr>
          <tr>
            <td>被叫号码</td>
            <td>{{currentCallRecord?.callee}}</td>
            <td>被叫归属地</td>
            <td>{{currentCallRecord?.calleeLocation}}</td>
          </tr>
          <tr v-if="currentCallRecord?.releaseTime">
            <td>发送满意度调查</td>
            <td>{{currentCallRecord?.satisfactionSurveyOffered?'是':'否'}}</td>
            <td>满意度结果</td>
            <td>{{satisfactionResultMap[currentCallRecord?.satisfaction]?.label}}</td>
            <!-- <td>{{currentCallRecord?.satisfaction}}</td> -->
          </tr>
          <tr v-if="fileUrl">
            <td>录音文件</td>
            <td colspan="3">
              <audio
                :controlslist="showControlslist"
                controls
                ref="audio"
                style="padding: 8px; min-width: 100%;"
                width="100%"
              >
                <source :src="fileUrl" />
              </audio>
            </td>
          </tr>
          <!-- <tr v-if="currentCallRecord?.releaseTime">
                  <td>挂断方</td>
                  <td>{{currentCallRecord?.releaseInitiator}}</td>
                  <td>挂断类型</td>
                  <td>{{$common.hangUpTypes[currentCallRecord?.hangUpType]}}</td>
          </tr>-->
        </table>
      </template>
      <table class="callRecordTable" v-else>
        <tr>
          <td>台账类型</td>
          <td>
            <dicLabel
              :value="ledgerForm?.callQueue"
              category="CALL_QUEUE"
              class="ledgerInfo"
              defaultValue="--"
            ></dicLabel>
          </td>
          <td>创建时间</td>
          <td>{{ledgerForm?.callTime}}</td>
        </tr>
        <tr v-if="ledgerForm?.callType=='INBOUND'">
          <td>主叫号码</td>
          <td>{{ledgerForm?.phoneNumber | desensitizedPhone}}</td>
          <td>主叫归属地</td>
          <td>{{ledgerForm?.phoneLocation || '--'}}</td>
        </tr>
        <tr v-else-if="ledgerForm?.callType=='OUTBOUND'">
          <td>呼出号码</td>
          <td>{{ledgerForm?.phoneNumber | desensitizedPhone}}</td>
          <td>呼出归属地</td>
          <td>{{ledgerForm?.phoneLocation || '--'}}</td>
        </tr>
        <tr>
          <td>开始时间</td>
          <td>{{ledgerForm?.callTime || '--'}}</td>
          <td>结束时间</td>
          <td>{{ledgerForm?.finishTime || '--'}}</td>
        </tr>
        <tr v-if="fileUrl">
          <td>录音文件</td>
          <td colspan="3">
            <audio
              :controlslist="showControlslist"
              controls
              ref="audio"
              style="padding: 8px; min-width: 100%;"
              width="100%"
            >
              <source :src="fileUrl" />
            </audio>
          </td>
        </tr>
      </table>
      <!-- <template v-if="fileUrl">
        <Divider orientation="left">录音文件</Divider>
        <audio
          :controlslist="showControlslist"
          controls
          ref="audio"
          style=" min-width: 100%;"
          width="100%"
        >
          <source :src="fileUrl" />
        </audio>
      </template>-->
    </div>

    <div
      class="selfPanel mt1 noBorder"
      v-if="ledgerForm && ['INBOUND', 'OUTBOUND'].indexOf(ledgerForm?.callType)  >= 0"
    >
      <Divider orientation="left">咨询内容</Divider>
      <div class="selfPanelContent">
        <Form :label-width="100" :model="ledgerForm" :rules="ledgerFormValidate" ref="ledgerForm">
          <Row>
            <template
              v-if="ledgerForm.mainBusinessTypeId && (ledgerForm.consultationType == undefinde || ledgerForm.consultationType == null || ledgerForm.consultationType == '')"
            >
              <Col :xs="24">
                <FormItem label="主业务类型" prop="mainBusinessTypeId">
                  <bussinessTypeTreeSelect
                    :disabled="true"
                    :multiple="false"
                    :value="ledgerForm.mainBusinessTypeId"
                    @change="changeMainBussinessTypeSet"
                    placeholder="请选择主业务类型"
                  />
                </FormItem>
              </Col>
              <Col :xs="24">
                <FormItem label="次业务类型">
                  <bussinessTypeTreeSelect
                    :disabled="true"
                    :multiple="true"
                    :values="ledgerForm.minorBusinessTypeIds"
                    @change="changeMinorBussinessTypeSet"
                    placeholder="请选择次业务类型"
                  />
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="咨询主题" prop="subject">
                  <Input
                    clearable
                    disabled
                    placeholder="请输入咨询主题"
                    type="text"
                    v-model.trim="ledgerForm.subject"
                  ></Input>
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="咨询归属地" prop="areaCodes">
                  <Cascader
                    :data="regionData"
                    change-on-select
                    disabled
                    placeholder="请选择咨询归属地"
                    v-model.trim="ledgerForm.areaCodes"
                  ></Cascader>
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="客户自述" prop="clientDescription">
                  <Input
                    :autosize="{ minRows: 3, maxRows: 10 }"
                    disabled
                    maxlength="1000"
                    show-word-limit
                    type="textarea"
                    v-model.trim="ledgerForm.clientDescription"
                  ></Input>
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="处理意见" prop="lawyerSuggestion">
                  <Input
                    :autosize="{ minRows: 3, maxRows: 10 }"
                    disabled
                    maxlength="1000"
                    show-word-limit
                    type="textarea"
                    v-model.trim="ledgerForm.lawyerSuggestion"
                  ></Input>
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="服务单号" prop="serviceNo">
                  <Input
                    disabled
                    placeholder="请输入服务单号"
                    type="text"
                    v-model.trim="ledgerForm.serviceNo"
                  ></Input>
                </FormItem>
              </Col>
              <Col :sm="12" :xs="24">
                <FormItem label="事件标签">
                  <Select
                    clearable
                    disabled
                    filterable
                    placeholder="请选择事件标签"
                    v-model="ledgerForm.eventTag"
                  >
                    <Option
                      :key="item.val"
                      :value="item.val"
                      v-for="item in eventTags"
                    >{{ item.label }}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :sm="12" :xs="24">
                <FormItem label="事发时间">
                  <Date-picker
                    @on-change="(val)=>{ledgerForm.sourceTime = val}"
                    disabled
                    format="yyyy-MM-dd HH:mm:ss"
                    placeholder="事发时间"
                    style="width: 100%"
                    type="datetime"
                    v-model="ledgerForm.sourceTime"
                  ></Date-picker>
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="事发地点">
                  <Input
                    clearable
                    disabled
                    placeholder="请输入事发地点"
                    type="text"
                    v-model.trim="ledgerForm.sourceAddress"
                  ></Input>
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="自定义标签" prop="tags">
                  <Select
                    @on-create="createTag"
                    allow-create
                    disabled
                    filterable
                    multiple
                    v-model="ledgerForm.tags"
                  >
                    <Option :key="item" :value="item" v-for="item in tagList">{{ item }}</Option>
                  </Select>
                </FormItem>
              </Col>
            </template>
            <template v-else>
              <Col :xs="24">
                <!-- <FormItem label="主业务类型" prop="mainBusinessTypeId">
                <bussinessTypeTreeSelect
                  :disabled="true"
                  :multiple="false"
                  :value="ledgerForm.mainBusinessTypeId"
                  @change="changeMainBussinessTypeSet"
                  placeholder="请选择主业务类型"
                />
                </FormItem>-->
                <FormItem label="咨询类型" prop="consultationTypes">
                  <Cascader
                    :data="consultationTypeTree"
                    :disabled="true"
                    filterable
                    v-model="ledgerForm.consultationTypes"
                  ></Cascader>
                </FormItem>
              </Col>
              <Col :xs="24">
                <FormItem label="案由" prop="causeOfActions">
                  <div class="flex">
                    <Cascader
                      :data="causeTree"
                      :disabled="true"
                      filterable
                      v-model="ledgerForm.causeOfActions"
                    ></Cascader>
                    <FormItem
                      :label-width="0"
                      :rules="[{ required: true, message: '请输入案由备注', trigger: 'blur' }]"
                      label
                      prop="causeRemark"
                      v-if="needCauseRemark"
                    >
                      <Input
                        clearable
                        disabled
                        maxlength="200"
                        placeholder="请输入案由备注"
                        show-word-limit
                        type="text"
                        v-model="ledgerForm.causeRemark"
                      ></Input>
                    </FormItem>
                  </div>
                </FormItem>
              </Col>
              <Col :sm="12" :xs="24">
                <FormItem label="所属区域" prop="areaCodes">
                  <Cascader
                    :data="regionData"
                    :disabled="true"
                    change-on-select
                    filterable
                    placeholder="请选择所属区域"
                    v-model.trim="ledgerForm.areaCodes"
                  ></Cascader>
                </FormItem>
              </Col>
              <Col :sm="12" :xs="24">
                <FormItem label="处理方式" prop="handlingMethod">
                  <labelValue
                    :category="'HANDLING_METHOD'"
                    :data="ledgerForm.handlingMethod"
                    :disabled="true"
                  ></labelValue>
                </FormItem>
              </Col>

              <Col :sm="24" :xs="24">
                <FormItem
                  :rules="[{ required: true, message: '请输入咨询标题', trigger: 'blur' }]"
                  label="咨询标题"
                  prop="subject"
                >
                  <Input
                    clearable
                    disabled
                    placeholder="请输入咨询主题"
                    type="text"
                    v-model.trim="ledgerForm.subject"
                  ></Input>
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="咨询内容" prop="clientDescription">
                  <Input
                    :autosize="{ minRows: 3, maxRows: 10 }"
                    disabled
                    maxlength="1000"
                    show-word-limit
                    type="textarea"
                    v-model.trim="ledgerForm.clientDescription"
                  ></Input>
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="答复意见" prop="lawyerSuggestion">
                  <Input
                    :autosize="{ minRows: 3, maxRows: 10 }"
                    disabled
                    maxlength="1000"
                    show-word-limit
                    type="textarea"
                    v-model.trim="ledgerForm.lawyerSuggestion"
                  ></Input>
                </FormItem>
              </Col>
              <Col :sm="24" :xs="24">
                <FormItem label="特殊情况备注" prop="remark">
                  <Input
                    :autosize="{ minRows: 3, maxRows: 10 }"
                    disabled
                    maxlength="255"
                    show-word-limit
                    type="textarea"
                    v-model.trim="ledgerForm.remark"
                  ></Input>
                </FormItem>
              </Col>
            </template>
          </Row>
        </Form>
      </div>
    </div>

    <div
      class="messageContianer selfPanel noBorder"
      v-if=" (['INBOUND', 'OUTBOUND'].indexOf(ledgerForm?.callType )>= 0 || ledgerForm.hlSerial?.startsWith( 'HL_')) && !showSimple"
    >
      <Divider orientation="left">实时转译记录</Divider>
      <div class="selfPanelContent">
        <!-- <GeminiScrollbar :autoshow="true"> -->
        <div v-if="conversationInfos?.length>0 && !ledgerForm.hlSerial?.startsWith( 'HL')">
          <div
            :class="['USER', 'customer'].indexOf(item.roleType) >= 0?'left conversationItem':'right conversationItem'"
            :key="index + '-conversationItem'"
            v-for="(item, index) in conversationInfos"
          >
            <template v-if="['USER', 'customer'].indexOf(item.roleType) >= 0">
              <h5 class="conversationItemRole">
                <img
                  :src="require('@/assets/static/images/im/consultant@2x.png')"
                  class="personIcon"
                />
                <span>{{item.role}}</span>
              </h5>
            </template>
            <template v-else>
              <h5 class="conversationItemRole">
                <span>{{item.role}}</span>
                <img :src="require('@/assets/static/images/im/lawyer@2x.png')" class="personIcon" />
              </h5>
            </template>
            <div class="conversationItemContent">{{item.words}}</div>
          </div>
        </div>
        <div style="line-height: 4rem;margin-left:5vw;margin-top:2vh;" v-else>暂无实时转译记录</div>
        <a href="#scrollToMe" ref="scrollToMe"></a>
        <!-- </GeminiScrollbar> -->
        <Spin class="selfSpin" v-if="loadingConversation">
          <Icon class="demo-spin-icon-load" size="18" type="ios-loading"></Icon>
          <div>加载中，请稍候...</div>
        </Spin>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'hldetail',
  props: {
    consultationInfo: {
      required: true,
      default: {}
    },
    showSimple: {
      required: false,
      default: false
    },
  },
  data () {
    return {
      fileUrl: null,
      satisfactionResultOptions: [],
      satisfactionResultMap: {},
      toolType: 'personInfo',
      statusCode: null,
      eventTags: [],
      spinShow: false,
      showPanel: false,
      activeConfig: {},
      ledgerForm: {},
      callTypes: {},
      currentCallRecord: null,
      currentUser: null,
      conversationInfos: [],
      keywords: [],
      loadingConversation: false,
      tagList: [],
      defaultTagList: [],
      callTypeOptions: [],
      ledgerFormValidate: {
        mainBusinessTypeId: [{ required: true, type: 'number', message: '请选择主业务类型', trigger: "change" }],
        consultationTypes: [{ required: true, type: 'array', message: '请选择咨询类型', trigger: "change" }],
        causeOfActions: [{ required: true, type: 'array', message: '请选择案由', trigger: "change" }],
        areaCodes: [{ required: true, type: 'array', message: '请选择所属区域', trigger: "change" }],
        handlingMethod: [{ required: true, message: '请选择处理方式', trigger: "change" }],
        mainBussinessTypeId: [{ required: true, message: '请选择主业务类型', trigger: "change" }],
        clientDescription: [{ required: true, message: '请输入客户自述内容', trigger: "blur" }],
        lawyerSuggestion: [{ required: true, message: '请输入处理意见', trigger: "blur" }],
        // leAges: [{ required: true, message: '请选择年龄段', trigger: "change" }],
        // leGender: [{ required: true, message: '请选择性别', trigger: "change" }],
        // leProfession: [{ required: true, message: '请选择职业', trigger: "change" }],
        // leConsultationType: [{ required: true, message: '请选择客户类别', trigger: "change" }],
        // leEducational: [{ required: true, message: '请选择学历', trigger: "change" }],
        // name: [{ required: true, message: '请填写咨询人姓名', trigger: 'blur' }],
        // subject: [{ required: true, message: '请填写咨询标题', trigger: "blur" }],
      },
      timerMessage: null,
      loadingPortrait: false,
      currentPhone: null,
      showLedger: false,
      regionData: [],

      consultationTypeTree: [],
      causeTree: [],
      needCauseRemark: false
    }
  },
  computed: {
    baseURL: function () {
      return this.$store.getters['systemSupport/systemSupport']?.HL || process.env.VUE_APP_API_ROOT
    },
    isAdmin: function () {
      return this.$store.getters['userInfo/isAdmin'] || false
    },
    systemRoles: function () {
      return (this.$store.getters['userInfo/user'] || {}).systemRoles || []
    },
    hasOperationRole: function () {
      return (this.systemRoles || []).indexOf('OPERATION_MANAGER') >= 0 || (this.systemRoles || []).indexOf('OPERATION') >= 0
    },
    showControlslist: function () {
      return (this.hasOperationRole || this.isAdmin) ? 'nofullscreen' : 'nodownload'
    }
  },
  watch: {
    edit: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.isEdit = val
      }
    },
    consultationInfo: {
      immediate: true,
      deep: true,
      handler: function (val, oldV) {

        // this.ledgerForm = Object.assign({}, val)
        if (val?.id != oldV?.id) {
          console.log(val, 'cId')
          this.ledgerInfo()
        }
      }
    }
  },
  methods: {
    initAreaTree: async function () {
      let that = this
      that.regionData = await this.$baseData.handleData(false, that.$apis.dictionaryManager.region.getLvTree, null) || []

      // this.$axios.post(that.$apis.dictionaryManager.region.getLvTree).then(res => {
      //   if (res.success) {
      //     that.regionData = res.result || []
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error('区域数据获取失败！')
      // }).then(val => {
      // })
    },
    getDataSourceOptions: async function () {
      this.dataSources = await this.$baseData.handleData(false, this.$apis.projectManagementApi.getDataSourceOptions, null)
    },
    getDataSourceName: function (dataSource) {
      let da = this.dataSources.filter(item => item.code == dataSource)
      if (da.length > 0) {
        return da[0].remark
      } else {
        return ''
      }
    },
    cancelLedger: function () {
      this.ledgerForm = {}
      this.currentCallRecord = null
      this.consultantInfo = null
      this.tagList = this.defaultTagList
      this.$emit('cancelLedger')
    },
    hotlineList: function () {
      this.$emit('hotlineList')
    },
    getBasePath: async function (fileId) {
      console.log('this.fileId', fileId)
      if (fileId) {
        let params = new this.$URLSearchParams()
        params.append("id", fileId)
        let data = await this.$axios.post(this.$apis.fileServerApi.getFileVisitedPath, params)
        this.fileUrl = data.result
      }
      // return data.result
    },
    ledgerInfo: function () {
      let that = this
      let params = new this.$URLSearchParams()
      that.showLedger = true
      that.ledgerForm = {}
      params.append("id", that.consultationInfo.id)
      that.$axios.post(that.$apis.ICHLApi.hotlineApi.ledgerInfo, params).then(res => {
        if (res.success) {
          that.ledgerForm = res.result?.ledger || {}
          that.currentCallRecord = res.result?.hlRecord || {}
          that.getBasePath(that.ledgerForm.fileId)
          // that.loadHLRecord()
          if (!this.showSimple) {
            this.callConversationInfo()
          }
          that.currentPhone = that.ledgerForm.phoneNumber
        } else {
          that.$Message.error({
            content: res.message || '获取台账记录失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('ledgerInfo error', err)
        that.$Message.error({
          content: '获取台账记录失败！',
          duration: 3
        })
      })
    },
    createTag: function (value) {
      let that = this
      this.$axios.post(this.$apis.ICHLApi.tag.saveOrUpdate, { name: value }).then(res => {
        if (res.success) {
          that.$Message.success("添加标签成功！")
          that.tagList.push(value)
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("添加标签成功！")
      })
    },
    scrollToDom (el) {
      this.$nextTick(() => { // 等待 DOM 渲染完成
        if (el) { // 如果元素存在，则滚动到目标位置
          el.scrollIntoView({ block: 'end', behavior: 'smooth' })
        }
      })
    },
    /**
     * 获取话务记录
     */
    // loadCallRecord: function (appId, serialNum) {
    //   let that = this
    //   that.currentCallRecord = null
    //   that.conversationInfos = []
    //   that.keywords = []
    //   let params = new this.$URLSearchParams()
    //   params.append("appId", appId)
    //   params.append("serialNum", serialNum)
    //   that.$axios.post(that.$apis.HLConfigApi.callRecord.loadCallRecord, params, { baseURL: this.baseURL }).then(res => {
    //     if (res.success) {
    //       that.currentCallRecord = res.result || {}
    //       that.loadingConversation = true
    //       that.callConversationInfo()
    //     } else {
    //       that.$Message.error({
    //         content: res.message || '获取话务记录失败！',
    //         duration: 3
    //       })
    //     }
    //   }).catch(function (err) {
    //     console.log('that error', err)
    //     that.$Message.error({
    //       content: '获取话务记录失败！',
    //       duration: 3
    //     })
    //   })
    // },
    /**
     * 获取话务文本
     */
    callConversationInfo: function () {
      let that = this
      let params = new this.$URLSearchParams()
      params.append("ledgerId", that.ledgerForm.id)
      that.$axios.post(that.$apis.ICHLApi.hotlineApi.ledgerConInfo, params).then(res => {
        if (res.success) {
          that.conversationInfos = res.result?.callConversationInfos || []
          that.keywords = res.result?.keywords || []
        } else {
          that.$Message.error({
            content: res.message || '获取通话文本内容失败！',
            duration: 3
          })
        }
      }).catch(function (err) {
        console.log('callConversationInfo error', err)
        that.$Message.error({
          content: '获取通话文本内容失败！',
          duration: 3
        })
      }).finally(() => {
        // that.scrollToDom(that.$refs.scrollToMe)
        that.loadingConversation = false
      })
    },
    initTagList: function () {
      let that = this
      this.tagList = []
      this.defaultTagList = []
      this.$axios.post(that.$apis.ICHLApi.tag.tagOptions).then(res => {
        if (res.success) {
          that.tagList = res.result || []
          that.defaultTagList = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error("获取知识标签失败！")
      })
    },
    getCallTypeOptions: function () {
      let that = this
      this.callTypes = {}
      this.$axios.post(that.$apis.ICHLApi.hotlineApi.getCallTypeOptions).then(res => {
        if (res.success) {
          that.callTypeOptions = res.result || []
          that.callTypeOptions.forEach(item => {
            that.callTypes[item.value] = item.label
          })
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error("获取呼叫类型参数失败！")
      })
    },
    initBaseData: function () {
      this.eventTags = []
      this.getDic("EVENT_TAG").then(val => {
        this.eventTags = val
      })
      this.getCallTypeOptions()
      this.initTagList()
      this.getDataSourceOptions()
    },
    changeMainBussinessTypeSet: function (data) {
      if (this.ledgerForm) this.ledgerForm.mainBusinessTypeId = data?.id + '' || null
    },
    changeMinorBussinessTypeSet: function (data) {
      let ids = []
      data.forEach((item) => { ids.push(item['id']) })
      if (this.ledgerForm) this.$set(this.ledgerForm, 'minorBusinessTypeIds', ids)
    },
    //暂存
    waitLedger: function () {
      let that = this
      this.spinShow = true
      this.ledgerForm.status = 'wait'
      if (this.ledgerForm.sourceTime) {
        this.ledgerForm.sourceTime = this.$moment(this.ledgerForm.sourceTime).format("YYYY-MM-DD HH:mm:ss")
      }
      if (this.ledgerForm.areaCodes && this.ledgerForm.areaCodes.length > 0) {
        this.ledgerForm.provinceCode = this.ledgerForm.areaCodes[0]
        this.ledgerForm.cityCode = this.ledgerForm.areaCodes.length > 1 ? this.ledgerForm.areaCodes[1] : null
        this.ledgerForm.areaCode = this.ledgerForm.areaCodes.length > 2 ? this.ledgerForm.areaCodes[2] : null
      } else {
        this.ledgerForm.provinceCode = null
        this.ledgerForm.cityCode = null
        this.ledgerForm.areaCode = null
      }
      this.$axios.post(this.$apis.ICHLApi.hotlineApi.saveOrUpdate, that.ledgerForm).then(res => {
        if (res.success) {
          that.$Message.success("操作成功！")
          that.hotlineList()
          that.cancelLedger()
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        console.log('waitLedger error', waitLedger)
        that.$Message.error("操作失败！")
      }).finally(() => {
        that.spinShow = false
      })
    },

    //保存台账
    saveLedger: function () {
      let that = this
      this.spinShow = true
      this.ledgerForm.status = 'finish'
      this.$refs["ledgerForm"].validate(valid => {
        if (valid) {
          if (this.ledgerForm.sourceTime) {
            this.ledgerForm.sourceTime = this.$moment(this.ledgerForm.sourceTime).format("YYYY-MM-DD HH:mm:ss")
          }
          if (this.ledgerForm.areaCodes && this.ledgerForm.areaCodes.length > 0) {
            this.ledgerForm.provinceCode = this.ledgerForm.areaCodes[0]
            this.ledgerForm.cityCode = this.ledgerForm.areaCodes.length > 1 ? this.ledgerForm.areaCodes[1] : null
            this.ledgerForm.areaCode = this.ledgerForm.areaCodes.length > 2 ? this.ledgerForm.areaCodes[2] : null
          } else {
            this.ledgerForm.provinceCode = null
            this.ledgerForm.cityCode = null
            this.ledgerForm.areaCode = null
          }
          that.$axios.post(this.$apis.ICHLApi.hotlineApi.saveOrUpdate, that.ledgerForm).then(res => {
            if (res.success) {
              that.$Message.success("操作成功！")
              that.hotlineList()
              that.cancelLedger()
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            console.log('saveLedger error', waitLedger)
            that.$Message.error("操作失败！")
          }).finally(() => {
            that.spinShow = false
          })
        } else {
          that.spinShow = false
          return false
        }
      })

    },
    loadSatisfactionResults: async function () {
      this.satisfactionResultOptions = await this.$baseData.handleData(false, this.$apis.common.satisfactionResultOptions, null) || []
      this.satisfactionResultOptions.forEach(item => {
        this.satisfactionResultMap[item.code] = item
      })
    },

    initConsultationType: async function () {
      let that = this
      this.consultationTypeTree = []
      let params = new this.$URLSearchParams()
      // params.append("includeEffc", true)

      this.consultationTypeTree = await this.$baseData.handleData(false, that.$apis.ICHLApi.ledgerDictionaryApi.allConsultationTypeTree, params) || []

      // this.$axios.post(that.$apis.ICHLApi.ledgerDictionaryApi.allConsultationTypeTree, params).then(res => {
      //   if (res.success) {
      //     that.consultationTypeTree = res.result || []
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error("获取咨询类型失败！")
      // })
    },
    initCauseTree: async function () {
      let that = this
      this.causeTree = []
      let params = new this.$URLSearchParams()
      // params.append("includeEffc", true)
      this.causeTree = await this.$baseData.handleData(false, that.$apis.ICHLApi.ledgerDictionaryApi.allCauseTree, params) || []

      // this.$axios.post(that.$apis.ICHLApi.ledgerDictionaryApi.allCauseTree, params).then(res => {
      //   if (res.success) {
      //     that.causeTree = res.result || []
      //   } else {
      //     that.$Message.error(res.message)
      //   }
      // }).catch(function (err) {
      //   that.$Message.error("获取案由树失败！")
      // })
    },
    loadCauseData: async function () {
      let that = this
      let params = new this.$URLSearchParams()
      params.append("fullCode", this.ledgerForm.causeOfAction)
      that.needCauseRemark = false
      that.$axios.post(that.$apis.ICHLApi.ledgerDictionaryApi.causeData, params).then(res => {
        console.log("loadCauseData", res)
        if (res.success) {
          that.needCauseRemark = res.result?.needRemark || false
        }
      })

    },
  },
  beforeMount () {
    this.initCauseTree()
    this.initConsultationType()
    this.initAreaTree()
    this.loadSatisfactionResults()
    this.initBaseData()
  },
  destroyed () {
    this.currentCallRecord = null
    window.workbench = null
  }
}
</script>
<style lang="less" scoped>
.selfPanelContent {
  // border-top: 1px solid #e8eaec;
  padding: 5px;
  position: relative;

  .conversationItem {
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;

    .conversationItemRole {
      font-size: 0.75rem;
      font-weight: 500;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 2px;

      .personIcon {
        width: 1.6rem;
        min-width: 1.6rem;
        margin: 0 5px;
      }
    }

    .conversationItemContent {
      background: #f0f0f0;
      border-radius: 4px;
      padding: 4px 8px;
      word-break: break-all;
      max-width: max-content;
      margin: 0 6px;
      max-width: 80%;
    }
  }

  .conversationItem.right {
    align-items: end;

    .conversationItemRole {
      justify-content: flex-end;
    }

    .conversationItemContent {
      background-color: #d3ddf1;
      max-width: 80%;
    }
  }

  .callRecordTable {
    width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    font-size: 0.85rem;
    color: #666;

    > tr {
      td {
        padding: 5px;
        border: 1px solid #fff;
      }

      > td:nth-of-type(odd) {
        background: #f8f8f8;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #999;
        text-align: right;
        width: 22%;
      }

      > td:nth-of-type(even) {
        word-break: break-all;
      }
    }
  }
}
</style>